import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero } from "@/components/Hero";
import { Reveal } from "@/components/Reveal";

export const Route = createFileRoute("/datenschutz")({
  head: () => ({
    meta: [
      { title: "Datenschutz — Tarifvergleiche.com" },
      {
        name: "description",
        content: "Datenschutzerklärung von Tarifvergleiche.com.",
      },
    ],
  }),
  component: DatenschutzPage,
});

const sections = [
  {
    title: "1. Verantwortlicher",
    body: (
      <>
        <p>
          iMPLI Informations-Systeme GmbH, Mellerswiesen 17, 34125 Kassel
          (Unternehmenssitz: Paderborn). Kontakt:{" "}
          <a href="mailto:jorek@impli.de" className="text-primary hover:underline">
            jorek@impli.de
          </a>
          . Details siehe Impressum.
        </p>
      </>
    ),
  },
  {
    title: "2. Hosting & Server-Logfiles",
    body: (
      <p>
        Beim Aufruf dieser Website verarbeitet der Hosting-Provider automatisch
        technische Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit des
        Zugriffs, aufgerufene Seite, Browsertyp) in Server-Logfiles. Das ist
        technisch notwendig, um die Website sicher und stabil auszuliefern
        (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
    ),
  },
  {
    title: "3. Kontaktformular",
    body: (
      <p>
        Wenn du das Kontaktformular nutzt, speichern wir die von dir
        angegebenen Daten (Name, E-Mail-Adresse, Nachricht) ausschließlich, um
        deine Anfrage zu bearbeiten (Art. 6 Abs. 1 lit. b DSGVO). Die Daten
        werden auf unserem eigenen Server abgelegt und nicht an Dritte
        weitergegeben.
      </p>
    ),
  },
  {
    title: "4. Chat-Assistent",
    body: (
      <p>
        Der Chat-Assistent leitet die von dir eingegebenen Nachrichten zur
        Beantwortung an einen Sprachmodell-Dienst weiter (Art. 6 Abs. 1 lit. f
        DSGVO, berechtigtes Interesse an einer hilfreichen Nutzerführung).
        Bitte gib im Chat keine sensiblen persönlichen Daten preis.
      </p>
    ),
  },
  {
    title: "5. Deine Rechte",
    body: (
      <p>
        Du hast das Recht auf Auskunft, Berichtigung, Löschung und
        Einschränkung der Verarbeitung deiner Daten sowie ein
        Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde. Wende dich
        dazu einfach an{" "}
        <a href="mailto:jorek@impli.de" className="text-primary hover:underline">
          jorek@impli.de
        </a>
        .
      </p>
    ),
  },
];

function DatenschutzPage() {
  return (
    <main className="relative">
      <SiteNav />

      <Hero
        eyebrow="Rechtliches"
        title="Datenschutz"
        subtitle="Kurz und verständlich: was wir wissen, wofür, und wie lange."
      />

      <section className="relative pb-32 px-6">
        <div className="mx-auto max-w-2xl">
          <Reveal>
            <div className="mb-8 flex items-start gap-3 rounded-xl border border-foreground/12 bg-card px-4 py-3 text-sm text-muted-foreground">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
              <p>
                Hinweis: Dieser Entwurf beschreibt die im Code dieser Website
                erkennbare Datenverarbeitung (Kontaktformular, Chat-Assistent,
                Server-Logfiles). Er ersetzt keine rechtliche Prüfung — bitte
                vor Veröffentlichung von einem Anwalt oder Datenschutzbeauftragten
                gegenprüfen lassen.
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="relative rounded-2xl border border-foreground/12 bg-card p-8 md:p-10 ticket-shadow space-y-8">
              <span className="punch-hole" />

              {sections.map((s, i) => (
                <div key={s.title}>
                  {i > 0 && (
                    <div className="mb-8 text-foreground/20">
                      <div className="barcode-rule" />
                    </div>
                  )}
                  <h2 className="font-display text-lg font-semibold mb-2 text-foreground">
                    {s.title}
                  </h2>
                  <div className="text-sm leading-relaxed text-muted-foreground">{s.body}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <SiteFooter />
    </main>
  );
}
